import script from "./MegaMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./MegaMobile.vue?vue&type=script&setup=true&lang=js"

import "./MegaMobile.vue?vue&type=style&index=0&id=21f829ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f829ae"]])

export default __exports__